import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./SurveyPage.scss";
import { PulseSurveyViewer } from "@pulselabs-ai/survey-handler";
import { sendToNativeApp } from "../../utils/nativeInterface";
import Loader from "../../components/PulseLoader/loader";
import { CaptureMethod } from "@pl-flight-recorder/web/services/MfaCaptureMethodService";
import MfaCaptureMethodService from "../../services/MfaCaptureMethodService";
import MfaSDKResponseService from "../../services/MfaSDKResponseService";

const SurveyPage: React.FC = () => {
  const { captureId, userId } = useParams<{
    captureId?: string;
    userId?: string;
  }>();
  const [surveyData, setSurveyData] = useState<CaptureMethod | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchSurvey = async () => {
      try {
        if (!captureId) {
          setError("Capture ID is required");
          return;
        }

        // if (!userId) {
        //   setError("User ID is required");
        //   return;
        // }

        const captureService = MfaCaptureMethodService.getInstance();
        const capture = await captureService.getCaptureMethod(
          parseInt(captureId),
        );

        setSurveyData(capture);
        setError(null);
      } catch (err) {
        console.error("Failed to fetch survey:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchSurvey();
  }, [captureId]);

  const handleSubmit = async (data: Record<string, unknown>) => {
    if (!captureId) {
      console.error("Missing required parameters");
      return;
    }

    if (userId) {
      const mfaSDKResponseService = MfaSDKResponseService.getInstance();
      try {
        const sdkResponse = await mfaSDKResponseService.saveCaptureResponse({
          captureId: captureId,
          userId: userId || "",
          surveyResponse: data,
          userMetadata: {
            // deviceType: "mobile",
            // osType: "iOS",
            // version: "16.0",
          },
        });

        // Send response ID to native app if available
        if (sdkResponse.surveyResponseId) {
          // console.log("Survey response ID:", sdkResponse.surveyResponseId);
          sendToNativeApp(sdkResponse.surveyResponseId.toString());
        }
      } catch (error) {
        console.error("Failed to save survey response:", error);
      }
    } else {
      // console.log("No user ID provided");
      // console.log(surveyData?.surveySchema);
      // console.log(data);
      sendToNativeApp(JSON.stringify(data || {}));
    }
  };

  if (loading) return <Loader />;
  if (error) return <div className="survey-error">{error}</div>;
  if (!surveyData) return <div className="survey-error">Survey not found</div>;
  // console.log("Survey data:", surveyData);

  return (
    <div className="survey-page">
      <PulseSurveyViewer
        surveyJson={JSON.stringify(surveyData.surveySchema)}
        onComplete={handleSubmit}
      />
    </div>
  );
};

export default SurveyPage;
